import createTheme from "@mui/material/styles/createTheme";

export const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      light: "#334a8f",
      main: "#001e61",
      dark: "#000c3a",
      contrastText: "#fff",
    },
    secondary: {
      light: "#eabf9d",
      main: "#cf895f",
      dark: "#8a5a3e",
      contrastText: "#000",
    },
  },
  typography: {
    button: {
      textTransform: "none",
    }
  }
});
